<template>
    <div>
        <div class="modal-card" style="width: auto" v-if="$store.getters.getUserauthResponse.account_info != undefined">
            
        <section class="modal-card-body" style="text-align: center">

            <span class="heading1">
                
                <span class="heading1">
                    <p v-if="$store.getters.getUserauthResponse.days_left<=7 && $store.getters.getUserauthResponse.days_left>0">
                        Your ETA account is valid for {{$store.getters.getUserauthResponse.days_left}} days only. 
                        please email us at reachus@eventsonline.app to renew your account.
                    </p>

                    <p v-else-if="$store.getters.getUserauthResponse.days_left == 0" class="label" style="font-size: 0.9em;">
                        Your ETA account has expired. please email us at reachus@eventsonline.app to renew your account.
                    </p>
                    
                    
                </span>
            </span>
            
        </section>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/modules/RenewApp/Index.vue